import { useState } from "react";
import Modal from "@mui/material/Modal";
import { useSelector, useDispatch } from "react-redux";

import BusinessCards from "../../Advisor/BusinessCards.js"
import { UserIcon } from "../../Advisor/ClientIndex/Team.js";
import { hasValidAdvisor } from '../../Advisor/BusinessCards.js';
import { toggleModal } from "../../../../reducers/modalReducer.js";
import TeamMemberList from "../../../../components/TeamMemberList/index.jsx";
import TeamMemberModal from "../../../../components/modals/TeamMember/index.jsx";

export default function CompanyTeamMembers({ profileClass, company, teamMembers, setEditUser, setUserAction, resendInviteMember, handleDeleteMember }) {

	const dispatch = useDispatch();
	let user = useSelector((state) => state.user);
	let modal = useSelector((state) => state.modal);
	let [selectedData, setSelectedData] = useState({});
	const [action, setAction] = useState("");
	const [memeberData, setMemberData] = useState({});
	let [hideUserIcon, setHideUserIcon] = useState(false);
	let [updateType, setUpdateType] = useState("profileImage");
	let [uploadImage, setUploadImage] = useState("");

	const handleMemberEdit = async (member) => {
		let permissions = company['memberPermissions'][member['_id']];
		await setEditUser({ ...member, permissions });
		setUserAction('Edit');
		dispatch(toggleModal({ open: 'editUser' }));
	};

	const getMembers = async () => {
		console.log("Get Members");
	}

	const handleCompanyMember = async (member, action) => {
		if (member) {
			setMemberData({
				firstName: member["firstName"],
				lastName: member["lastName"],
				email: member["email"],
				designation: member["designation"],
				isDisable: user?._id === member?._id ? false : true,
				isSuperUser: user?.["createdBy"] ? false : true,
				phone: member["phone"] && member["phone"] !== undefined && member["phone"] !== 'undefined' ? member["phone"] : '+44',
				linkedIn: member["linkedIn"] ? member["linkedIn"] : '',
				profile: member["profile"] ? member["profile"] : ''
			});
		}
		setAction(action);
		dispatch(toggleModal({ open: "teamPopup" }));
	};

	const onModalClose = () => dispatch(toggleModal({ open: "" }));

	return (
		<>
			<div className="df jcc fdc pr mb5rem">
				<TeamMemberList
					userType="company"
					team={teamMembers}
					user={user}
					profileClass={profileClass}
					setSelectedData={setSelectedData}
					hasValidAdvisor={hasValidAdvisor}
					showEditButton={(item) => item?.hasEditButton || (user && user.role.toLowerCase() === "advisor" && item?.role?.toLowerCase() === "advisor")}
					handleEditRoute={(item) => item?.editRoute || (() => handleMemberEdit(item))}
					handleAdvisor={() => setSelectedData({ ...selectedData, hasEditButton: false })}
					setResendAdvisor={() => setSelectedData({ ...selectedData, hasEditButton: false })}
					handleCompanyMember={handleCompanyMember}
					UserIcon={UserIcon}
					company={company}
				/>
			</div>

			{/* Business Card Modal */}
			<Modal open={Object.keys(selectedData).length} onClose={() => setSelectedData({})} className="td500 zi4 pf t0 l0 w100 h110vh df jcc aic">
				<BusinessCards
					user={user}
					company={company}
					selectedData={selectedData}
					profileClass={profileClass}
					setSelectedData={setSelectedData}
				/>
			</Modal>

			<TeamMemberModal
				userType="company"
				modal={modal}
				getAdvisors={getMembers}
				onModalClose={onModalClose}
				setUpdateType={setUpdateType}
				setUploadImage={setUploadImage}
				user={user}
				action={action}
				advisorData={memeberData}
				selectedData={memeberData}
				setSelectedData={setMemberData}
				setAdvisorData={setMemberData}
				profileClass={profileClass}
				hideUserIcon={hideUserIcon}
			/>

		</>
	);
}
